import { ReactNode } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { Order } from '@anytag/graphql';

export interface GenericOption<V, L = string> {
  value: V;
  label?: L;
}

export interface SelectOption<V extends string, L = ReactNode> extends GenericOption<V, L> {
  prefixIcon?: ReactNode;
  submenu?: Omit<SelectOption<V>, 'submenu'>[]; // support 1 level submenu for now, submenu value type is the same as the parent option value type
  _isNew?: boolean; // internally used to indicate if the option is newly created
}

export interface CountryOption extends SelectOption<string, string> {
  currency?: string;
}

export interface DropdownOption<V extends string = string, L = ReactNode> extends GenericOption<V, L> {
  gtmId?: string;
  hidden?: boolean;
  active?: boolean;
  className?: string;
  disabled?: boolean;
  prefixIcon?: ReactNode;
  menuType?: MenuTypeLevel;
  submenu?: DropdownOption<V>[];
  onClick?: (o: DropdownOption<V>) => void;
}

// TODO: remake this Option, we have many kind of Option but this is 1 for all,
// it's hard to maintain and extend for each case so we need to split it into more specific types like CountryOption, DropdownOption, etc.
export interface Option<V = string, L = string> extends GenericOption<V, L> {
  order?: Order | null;
  gtmId?: string;
  title?: string;
  active?: boolean;
  disabled?: boolean;
  __isNew__?: boolean;
  prefixIcon?: ReactNode;
  submenu?: GenericOption<V>[];
  css?: Interpolation<Theme>;
}

export enum ToggleOption {
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}

export enum SelectedRangeOption {
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  THIS_WEEK = 'This week',
  LAST_WEEK = 'Last week',
  LAST_SEVEN_DAYS = 'Last 7 days',
  LAST_TWO_WEEKS = 'Last two weeks',
  LAST_MONTH = 'Last month',
  THIS_MONTH = 'This month',
  ALL_TIME = 'All time',
  TODAY_TO_MONTH_AGO = 'Last 30 days',
  CUSTOM = 'Custom',
  CLEAR = 'Clear'
}
export enum TtcmStatusOption {
  ALL = 'ALL',
  TTCM = 'TTCM',
  NON_TTCM = 'NON_TTCM'
}
export enum MenuTypeLevel {
  MULTI_LEVEL = 'multi-level',
  SINGLE_LEVEL = 'single-level'
}

// Make some optional fields
export type WithOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
